import React, {PureComponent} from 'react';
import {withTranslation} from 'react-i18next';

import axios from "../../../../../axios-defaults";
import Spinner from "../../../../UI/Spinner";
import UserContext from '../../../../../context/user-context';

import './css/Form.css';
import RealexHpp from "../../../../../rxp-js";
import {fireGTMPaymentEvent, returnTranslatedPaymentMethod} from "../../../../Utils/GTM/GTMHelper";

class Pay extends PureComponent {
    static contextType = UserContext;

    constructor(props) {
        super(props);

        this.state = {
            show_spinner: true,
            invoices: props.invoices,
            amount: props.amount,
            bank_resume:false,
            error_message:'',
            verify:true
        }
        this.chargeAndSaveBank = this.chargeAndSaveBank.bind(this);
    }

    chargeAndSaveBank = (message) => {
        if(typeof message?.data?.Step !== 'undefined' && message.data.Step === 'LINK') {
            $('#vopay-pay-container').hide();
            this.setState({
                show_spinner: true
            });
            this.props.resetMessages()

            let save_bank = false;
            let saveCheckbox = document.querySelector('[data-mxo-selector="save-checkbox"]');

            if(this.props.save !== false && typeof saveCheckbox !== 'undefined' && saveCheckbox !== null){
                save_bank = saveCheckbox.checked;
            }

            axios.post(`/banks/chargeAndSaveBank`, {
                data: message.data,
                amount: this.props.amount,
                account: this.context.user.account,
                paymentOption: this.props.paymentOption,
                invoices: this.props.invoices,
                save_bank: save_bank
            } )
                .then(response => {
                    this.setState({show_spinner: false})
                    if (response.data.responseMessage !== undefined) {
                        this.props.handleShowMessage('error',this.props.t(response.data.responseMessage));
                        this.prepareBankForm();
                    } else {
                        this.props.handleShowMessage('confirmation',response.data.orderId)
                        this.props.setBankUsed(response.data.bank_data)
						const invoicesCount = this.props.invoices.length;
						const invoicesTotal = this.props.amount;
						fireGTMPaymentEvent('3_succes', {mode : returnTranslatedPaymentMethod(this.props.paymentOption), type : `banque-nouvelle`, invoicesCount, invoicesTotal});
                    }
                    this.props.refreshBanksList();
                })
                .catch(error => {
                    console.log('/banks/chargeAndSaveBank error');
					fireGTMPaymentEvent('9_echoue', {mode : returnTranslatedPaymentMethod(this.props.paymentOption), type : `banque-nouvelle`});
					if (error.response.status){
                        switch(error.response.status){
                            case 408:
                                this.props.handleShowMessage('error',this.props.t('payment.error_message.timeout'))
                                break;
                            default:
                                this.props.handleShowMessage('error',this.props.t('payment.error_message.general_support'))
                        }
                    }
                    else{
                        this.props.handleShowMessage('error',this.props.t('payment.error_message.general_support'))
                    }


                });
        }
    }

    prepareBankForm = async () => {
        this.setState({url:null});
        await axios.get(`/vopay/return-iq11-generated-embed-url`)
            .then(response => {
                this.setState({loading:false});
                this.setState({show_spinner:false});
                //console.log('response.data.url: ');
                //console.log(response.data.url);
                $('#vopay-pay-container').show();
                this.setState({url:response.data.url});

                window.addEventListener('message', this.chargeAndSaveBank, false);

                setTimeout(function(){
                    //this.setState({show_spinner:false})
                    //$('#vopay-pay-container').show();
                }.bind(this),1000)

            }).catch(error => {
                console.log('[Profile/SavedPaymentMethods/Banks/Forms/Pay.js] : Ajax error in componentDidMount()', error.message);
            });
    }

    async componentDidMount() {
        await this.prepareBankForm()
    }
    componentWillUnmount() {
        window.removeEventListener('message', this.chargeAndSaveBank, false);
    }
    render()
    {
        const {show_spinner,bank_resume,error_message,url} = this.state;
        const {save} = this.props;
        // Si save est explicitement défini comme false, on cache l'option de sauvegarde
        const showSaveOption = save !== false;

        return (
            <div className="container container--larger">
                {show_spinner ? <Spinner />: null}
                {error_message? <p className={'alert alert-danger'}>{error_message}</p>:null }
                {bank_resume ? bank_resume :
                    <div id={'vopay-pay-container'}>
                        {showSaveOption && (
                            <label className="checkbox-field checkbox-field--gray mb-3 pl-1 mt-2" htmlFor="save-checkbox">
                                <input type="checkbox" name="save-checkbox" id="save-checkbox"
                                    data-mxo-selector="save-checkbox" />
                                <span></span>
                                <strong>&nbsp;{this.props.t('payment.savecard')}</strong>
                            </label>
                        )}
                        <iframe src={url}>
                        </iframe>
                    </div>
                }
            </div>
        );
    }
}

export default withTranslation()(Pay);



